import color from '../../util/color';

export var input = {
  display: 'inline-block',
  height: 20,
  padding: '4px 6px',
  marginBottom: 0,
  marginLeft: 0,
  fontSize: 14,
  lineHeight: '20px',
  color: color.charcoal,
  WebkitBorderRadius: 4,
  MozBorderRadius: 4,
  borderRadius: 4,
  border: '1px solid ' + color.light_gray,
  verticalAlign: 'middle'
};

export var enumInput = {
  marginBottom: 0,
  border: '1px solid ' + color.light_gray
};

export var container = {
  paddingLeft: 20,
  marginBottom: 8
};

export var maxWidth = {
  maxWidth: 245
};

export var description = {
  paddingLeft: 2
};

export var checkbox = {
  width: 20,
  height: 20,
  fontSize: 20,
  paddingLeft: 2
};

export var link = {
  cursor: 'pointer'
};
